import makeStyles from "e100-react-components/lib/styles/makeStyles";

export const useStyles = makeStyles(({ spacing, palette }) => ({
  avatar: {
    color: "#515B69",
    backgroundColor: "rgba(81, 91, 105, 0.1)",
  },
  contentRoot: {
    paddingTop: spacing(1.5),
    paddingBottom: spacing(1.5),
    paddingLeft: spacing(2),
    paddingRight: spacing(2),
    gap: `0 ${spacing(2)}px`,
  },
  itemPadding: {
    paddingBottom: spacing(0.5),
  },
  itemText: {
    flexGrow: 2,
  },
  battery: {
    transform: "translate(0, -2px) rotate(90deg)",
    color: "#515B69",
  },
  button: {
    backgroundColor: "transparent",
    padding: "0",
    border: "none",
    width: "100%",
    textAlign: "left",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: palette.background.default,
    },
  },
}));
